export const iconFontAwesomeMapsBasketShopping = (
	<i className="fa-solid fa-basket-shopping"></i>
);
